import { RouteRecordRaw } from 'vue-router';
import { featureFlags } from '@/featureFlags';

export const patentFtoRouteConfig: RouteRecordRaw = {
  name: 'patentFto',
  path: '/patent-fto',
  component: () => import('@/components/patent-fto/main.vue'),
  meta: { accessScope: 'patent_fto' },
  children: [
    {
      path: '/patent-fto/patent-fto-projects',
      component: () =>
        import('@/components/patent-fto/patent-fto-projects.vue'),
      name: 'patentFtoProjects',
      meta: { title: 'プロジェクト', type: 'patentFtoProject' },
    },
    {
      path: '/patent-fto/projects/:id',
      component: () =>
        import('@/components/patent-fto/patent-fto-project-detail.vue'),
      name: 'patentFtoProjectDetail',
      redirect: { name: 'patentFtoProjectAnalyses' },
      meta: { title: 'プロジェクト詳細', type: 'patentFtoProject' },
      children: [
        {
          path: 'analyses',
          name: 'patentFtoProjectAnalyses',
          component: () =>
            import('@/components/patent-fto/patent-fto-project-analyses.vue'),
          meta: {
            title: 'プロジェクト調査結果',
            type: 'patentFtoProject',
          },
        },
      ],
    },
    {
      path: '/patent-fto/patent-fto-analyses',
      component: () =>
        import('@/components/patent-fto/patent-fto-analyses.vue'),
      name: 'patentFtoAnalyses',
      meta: { title: '調査', type: 'patentFtoAnalysis' },
    },
    {
      path: '/patent-fto/analyses/:id',
      component: () =>
        import(
          '@/components/patent-fto/patent-fto-analysis/patent-fto-analysis-detail.vue'
        ),
      name: 'patentFtoAnalysisDetail',
      props: true,
      redirect: { name: 'patentFtoAnalysisResult' },
      children: [
        {
          path: 'result',
          name: 'patentFtoAnalysisResult',
          component: () =>
            import(
              '@/components/patent-fto/patent-fto-analysis/result/patent-fto-analysis-result.vue'
            ),
          props: true,
          meta: { title: '調査結果', type: 'patentFtoAnalysis' },
        },
        {
          path: 'condition',
          name: 'patentFtoAnalysisCondition',
          component: () =>
            import(
              '@/components/patent-fto/patent-fto-analysis/condition/patent-fto-analysis-condition.vue'
            ),
          props: true,
          meta: { title: '調査条件', type: 'patentFtoAnalysis' },
        },
        {
          path: 'verifications',
          name: 'patentFtoAnalysisVerifications',
          component: () =>
            import(
              '@/components/patent-fto/patent-fto-analysis/verifications/patent-fto-analysis-verifications.vue'
            ),
          props: true,
          meta: { title: '検証結果', type: 'patentFtoAnalysis' },
          // flag off のときは直接 URL アクセスも弾く
          beforeEnter: () =>
            featureFlags.ANDEV_9591_PATENT_FTO_CLAIM_VERIFICATION
              ? true
              : { name: 'patentFtoAnalysisResult' },
        },
      ],
    },
    {
      path: '/patent-fto/settings/notification',
      component: () =>
        import(
          '@/components/patent-fto/settings/patent-fto-notification-settings.vue'
        ),
      name: 'patentFtoSettingsNotification',
      meta: { title: '通知', type: 'patentFtoSettings' },
    },
  ],
};
